<template>
  <el-dialog
    title="查看队列信息"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <!-- 队列状态;1.已收车  2.已查验 3.未办结 4.已办结 5.已领车 6.已拆解 7.已销售 -->
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车主信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="车牌号">
            <div class="text">{{ form.LicensePlate | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车架号后6位">
            <div class="text">{{ form.Vin6 | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆编号">
            <div class="text">{{ form.CarId | gang }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">整车进度</div>
      </div>
      <!-- <= 3
              ? this.form.QueueStatus
              : this.form.QueueStatus - 1 -->
      <div style="height: 500px; margin-top: 15px">
        <el-steps
          direction="vertical"
          process-status="wait"
          :active="this.form.QueueStatus"
        >
          <el-step
            title="已收车"
            :description="step1Description"
            class="step-description"
          >
          </el-step>
          <el-step
            title="已查验"
            :description="step2Description"
            class="step-description"
          ></el-step>
          <el-step
            title="已办结"
            :description="step3Description"
            class="step-description"
          ></el-step>
          <!-- <el-step
            title="已办结"
            :description="step6Description"
            class="step-description"
          ></el-step> -->
          <el-step
            title="已领出"
            :description="step4Description"
            class="step-description"
          ></el-step>
          <el-step
            title="已拆解"
            :description="step5Description"
            class="step-description"
          ></el-step>
        </el-steps>
      </div>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      step5Extend: "", //拆解详细
      form: {},
    };
  },
  methods: {
    UserNameInfo(value, def = "-") {
      // 处理收车人信息
      if (!value) {
        return def;
      } else {
        let item = this.$store.state.UserNameInfo.find(
          (r) => r.UId == value
        )?.Username;
        if (!item) {
          return def;
        }
        return item;
      }
    },
    //物料拆解信息
    MeterialInfo(value, def = "-") {
      console.log("获取拆解信息", value);
      // 处理收车人信息
      if (!value) {
        this.step5Extend = "";
      } else {
        this.$get("MaterialEntryRecords/GetList", {
          CarId: value,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        }).then((res) => {
          var info = "";
          if (res.Rows > 0) {
            res.Result.forEach((element) => {
              console.log(element);
              info += `入库物料：${this.gang(
                element.MaterialName
              )}，入库重量：${this.gang(element.Weight)}，入库仓库：${this.gang(
                element.WarehouseName
              )}，入库人：${this.gang(element.Operator)}\n`;
            });
            console.log(info, "拆解信息");
          }
          this.step5Extend = info;
        });
      }
    },
    gang(value, def = "-") {
      if (!value) {
        return def;
      } else {
        return value;
      }
    },
  },
  computed: {
    step1Description() {
      return `收车人：${this.UserNameInfo(
        this.form.CreateUserId
      )}，收车时间：${this.gang(this.form.CreateTime)}`;
    },
    step2Description() {
      return `查验人：${this.UserNameInfo(
        this.form.InspectorUserId
      )}，查验时间：${this.gang(this.form.InspectorDate)}`;
    },
    step3Description() {
      return (
        `称重人：${this.UserNameInfo(
          this.form.WeighUser
        )}，称重时间：${this.gang(this.form.WeighDate)}\n` +
        `登记人：${this.UserNameInfo(
          this.form.RegUserId
        )}，登记时间：${this.gang(this.form.RegDate)}\n` +
        `结算人：${this.UserNameInfo(
          this.form.SettleUserId
        )}， 结算时间：${this.gang(this.form.SettleDate)}\n` +
        `毛重：${this.gang(this.form.GrossWeight)}kg，皮重：${this.gang(
          this.form.TareWeight
        )}kg，净重：${this.gang(this.form.CarWeigh)}kg\n` +
        `单价：${this.gang(this.form.UnitPrice)}元，扣杂费用：${this.gang(
          this.form.MiscellaneousExpenses
        )}元，附加费用：${this.gang(
          this.form.Surcharge
        )}元，结算价：${this.gang(this.form.SettlementPrice)}元`
      );
    },
    step4Description() {
      return `领出人：${this.UserNameInfo(
        this.form.DisassembleUser
      )}，领出时间：${this.gang(this.form.DisassembleDate)}`;
    },
    step5Description() {
      return (
        `拆解人：${this.UserNameInfo(
          this.form.DisassembleFinshUserId
        )}，拆解时间：${this.gang(this.form.DisassembleFinshDate)}\n` +
        this.step5Extend
      );
    },
    step6Description() {
      return "-";
    },
  },
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("RegisterQueue/GetItem", {
          KeyId: v.KeyId,
        }).then((r) => {
          this.form = { ...r.Result };
          this.MeterialInfo(this.form.CarId);
        });
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
::v-deep .el-step__description {
  white-space: pre-line; /* 使\n能够被解析为换行 */
  word-break: break-word; /* 可选：防止长文本溢出 */
}
</style>